
import * as Socket from './socket.js';
// import * as Socket from 'unete-io/socket';
import { InspectService } from './services';
import { reportIfInvalidSession } from './@utils/invalid-session';
import { DataRegistryService } from './data-registry.service.js';
import { NotificationsDictionary } from "./@lang/notifications-dictionary";

interface RecursiveProxyOptions {
    recursive: true;
    path?: string[];

    apply?: (path: string[], args: any[]) => any;
    get?: (path: string[]) => any;
    new?: (path: string[], args: any[]) => any;
}

interface ElasticProxyOptions {
    recursive?: false;

    set?: (path: string, prop: any) => void;
    get?: (path: string) => any;
    apply?: (args: any[]) => any;
    new?: (args: any[]) => any;
}

export class ElasticProxy {

    static new<T>(options: ElasticProxyOptions | RecursiveProxyOptions) {
        if (options.recursive) return ElasticProxy.newRecursive(options);
        const opts: ElasticProxyOptions = options as ElasticProxyOptions;

        return new Proxy(function () { }, {

            get(target, prop: string, receiver) {
                return opts.get && opts.get(prop);
            },

            set(target, prop: string, value, receiver) {
                opts.set && opts.set(prop, value)

                return true;
            },

            apply(target, thisArg, args) {
                return opts.apply && opts.apply(args);
            },

            construct(target, args) {
                return opts.new && opts.new(args);
            }

        });
    }

    static newRecursive(options: RecursiveProxyOptions) {
        if (!options.path) options.path = [];

        return ElasticProxy.new({
            recursive: false,

            get(prop: string) {
                const result = options.get && options.get([...options.path, prop]);
                return result || ElasticProxy.new({
                    recursive: true,
                    path: [...options.path, prop],
                    apply: options.apply,
                    new: options.new
                })
            },

            apply(args: any[]) {
                return options.apply && options.apply(options.path, args);
            },

            new(args: any[]) {
                return options.new && options.new(options.path, args);
            }
        })
    }

}

let nonce = 0;


export let calls: Call[] = [];

interface Call {
    host: string;
    path: string[];
    startDate: Date;
    endDate: Date;
    duration: number;
}

function translate(name: string, data: any = {}) {
    try {
        let msg = NotificationsDictionary[name];
        if (msg === undefined) return undefined;
        for (const fieldName in data) {
            msg = msg.replace(new RegExp(`{{${name}}}`, "g"), data[fieldName]);
        }

        return msg;
    } catch (error) {
        console.log(error);
    }
}

export function UneteDebugClient(url: string) {
    const unete = Socket(url, {}, {
        private_functions: {
            // $before_client_call: (args) => console.log("HOLA", args)
        }
    });
    // const unete = Socket(url)

    return ElasticProxy.new({
        recursive: true,
        get(path: string[]) {
            if (path.join(".") === "$sock") return unete.$sock;
        },
        async apply(path: string[], args: any[]) {
            let method = unete;
            for (const key of path) {
                method = method[key];
            }
            const startingDate = new Date();
            try {
                var res = await eval(`method(...args)`);
            } catch (exc) {
                const endingDate = new Date();
                try {
                    var message = JSON.parse(exc || exc.message)
                } catch (e) {
                    let lastChance = typeof exc === 'string' ? exc : exc.message;
                    let translateMessage = translate(lastChance)
                    if (!translateMessage) {
                        // console.error("This message dont have translation", exc.message || exc);
                        throw exc
                    } else {
                        throw new Error(translateMessage);
                    }
                }

                throw new Error(translate(message.errorCode, message.data))
            }
            const endingDate = new Date();

            return res;
        }
    })
}

// Unete Service
export class UneteIO {
    static inspect = new InspectService()
    constructor() { }

    static socket(url, ds?: DataRegistryService) {
        const unete = Socket(url, {}, {
            private_functions: {
                $before_client_call: (args) => this.createRequestReport(args),
                $after_client_call: (args) => this.modifyTime(args),
                $after_client_error: (args) => this.modifyRequest(args.iid, 'error', args.error)
            }
        });
        // const unete = Socket(url)

        return ElasticProxy.new({
            recursive: true,
            get(path: string[]) {
                if (path.join(".") === "$sock") return unete.$sock;
            },
            async apply(path: string[], args: any[]) {
                let method = unete;
                for (const key of path) {
                    method = method[key];
                }
                const startingDate = new Date().getTime();

                ds?.send('requests', {
                    type: "request",
                    path, args: args.map(arg => typeof arg === "function" ? "<Function>" : arg),
                    timestamp: Date.now()
                });
                try {
                    var res = await eval(`method(...args)`);

                    // try { throw new Error() } catch (e) { console.log(path.join("."), e.stack) }

                    ds?.send('requests', {
                        type: "response",
                        status: 'ok',
                        path, args: args.map(arg => typeof arg === "function" ? "<Function>" : arg),
                        start: startingDate,
                        end: Date.now(),
                        duration: Date.now() - startingDate,
                    });
                } catch (exc) {
                    reportIfInvalidSession(typeof exc === 'string' ? exc : exc?.message, args);
                    ds?.send('requests', {
                        type: "response",
                        status: 'error',
                        path, args: args.map(arg => typeof arg === "function" ? "<Function>" : arg),
                        start: startingDate,
                        end: Date.now(),
                        duration: Date.now() - startingDate,
                        error: exc
                    });

                    try {
                        var message = JSON.parse(exc || exc.message)
                    } catch (e) {
                        let lastChance = typeof exc === 'string' ? exc : exc.message;
                        let translateMessage = translate(lastChance)
                        if (!translateMessage) {
                            // console.error("This message dont have translation", exc.message || exc);
                            throw exc
                        } else {
                            throw new Error(translateMessage);
                        }
                    }
                    throw new Error(translate(message.errorCode, message.data))
                }

                // console.info(`${path.join('.')} - ${new Date(endingDate.getTime() - startingDate.getTime()).getMilliseconds()}ms`)
                // calls.push({
                //     host: url,
                //     path,
                //     startDate: startingDate,
                //     endDate: endingDate,
                //     duration: endingDate.getTime() - startingDate.getTime()
                // })

                return res;
            }
        })
    }

    static createRequestReport(request: any) {
        const { iid, path, port, hash } = request;
        let stack: string;

        this.inspect.add({
            id: iid,
            start: new Date().getTime(),
            end: 0,
            service: port,
            hash,
            endpoint: path.join('.'),
            stack
        })
    }

    static modifyRequest(iid: string, property: string, value: any) {
        // @ts-ignore
        this.inspect.modify(iid, [property, value])
    }

    static modifyTime({ iid }: any) {
        this.inspect.modify(iid, ['end', new Date().getTime()])
    }

    static get inspector() {
        return this.inspect;
    }
}
